module.exports = __webpack_public_path__ + "img/femme-shampoing-95447834.9945d9bd.jpg";